import React from 'react';
import { useUsers } from '../context/UsersContext';
import { HiUsers } from 'react-icons/hi2';
import { MdShield, MdWork, MdPerson, MdPersonOff } from 'react-icons/md';

export default function UserStatsGrid() {
  const { stats: counts, loading, error } = useUsers();
  const stats = [
    {
      id: 1,
      title: 'Total Users',
      value: counts.total,
      subtitle: 'All users in system',
      icon: HiUsers,
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600',
    },
    {
      id: 2,
      title: 'Admins',
      value: counts.admins,
      subtitle: 'Full access',
      icon: MdShield,
      bgColor: 'bg-blue-50',
      iconColor: 'text-blue-600',
    },
    {
      id: 3,
      title: 'Branch Managers',
      value: counts.managers,
      subtitle: 'Operation access',
      icon: MdWork,
      bgColor: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
    },
    {
      id: 4,
      title: 'Staff',
      value: counts.staff,
      subtitle: 'Task access',
      icon: MdPerson,
      bgColor: 'bg-amber-50',
      iconColor: 'text-amber-500',
    },
    {
      id: 5,
      title: 'Inactive Users',
      value: counts.inactive,
      subtitle: 'Not active',
      icon: MdPersonOff,
      bgColor: 'bg-slate-50',
      iconColor: 'text-slate-500',
    },
  ];

  return (
    <div className="mb-5 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5">
      {stats.map((item) => {
        const IconComponent = item.icon;
        return (
          <div
            key={item.id}
            className="flex items-start gap-4 rounded-xl border border-slate-200/70 bg-white p-4 shadow-sm lg:py-5"
          >
            {/* Circular Icon Wrapper */}
            <div className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full ${item.bgColor}`}>
              <IconComponent className={`h-7 w-7 ${item.iconColor}`} />
            </div>

            {/* Labels and Metrics */}
            <div className="flex flex-col min-w-0">
              <span className="text-xs font-semibold text-slate-900">
                {item.title}
              </span>
              <span className="my-1 text-3xl font-bold leading-tight text-slate-950">
                {loading || error ? '—' : item.value}
              </span>
              <span className="mt-1 text-xs text-slate-500">
                {item.subtitle}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
